import { keycloakAdapter } from '../apiv2';
import { inferProfileUrl } from '../utils';
import { find, get } from 'lodash';

const state = {
    patients: [],
    loggedUser: false,
    loggedUserCommunication: false,
    loading: false,
    locale: null,
    isKcInitError: false,
};

const getters = {
    getLoggedUser(state) {
        return state.loggedUser;
    },
    getLoggedUserCommunication(state) {
        return state.loggedUserCommunication;
    },
    getProfileUrl() {
        return inferProfileUrl();
    },
    getPatients(state) {
        return state.patients;
    },
    getOwnerPatient(state) {
        const owner = find(state.patients, { associationType: 'owner' });
        return owner || {};
    },
    getIsOwnerRegisterComplete(state, getters) {
        if (!getters.getOwnerPatient) return false;
        return !!(get(getters.getOwnerPatient, 'firstName') && get(getters.getOwnerPatient, 'lastName'));
    },
    getLoading(state) {
        return state.loading;
    },
    getLocale(state) {
        return state.locale;
    },
    getIsKcInitError(state) {
        return state.isKcInitError;
    },
};

const mutations = {
    SET_LOGGED_USER(state, user) {
        state.loggedUser = user;
    },
    SET_LOGGED_USER_COMMUNICATION(state, payload) {
        state.loggedUserCommunication = payload;
    },
    SET_PATIENTS(state, patients) {
        state.patients = patients;
    },
    SET_LOADING(state, payload) {
        state.loading = payload;
    },
    SET_LOCALE_FOR_PROFILE(state, locale) {
        state.locale = locale;
    },
    SET_IS_KC_INIT_ERROR(state, payload) {
        state.isKcInitError = payload;
    },
};

const actions = {
    async logout({ commit }, establishmentId) {
        try {
            commit('SET_LOADING', true);
            await keycloakAdapter.logout(establishmentId);
            commit('SET_LOGGED_USER', null);
            commit('SET_PATIENTS', []);
            return true;
        }
        catch(e) {
            return false;
        }
        finally {
            commit('SET_LOADING', false);
        }
    },
    async onLoginSuccess({ dispatch, commit }) {
        commit('SET_LOADING', true);
        try {
            await Promise.all([
                await dispatch('fetchLoggedUser'),
                await dispatch('fetchPatients'),
                await dispatch('fetchLoggedUserCommunication'),
            ]);
        }
        finally {
            commit('SET_LOADING', false);
        }
    },
    async fetchLoggedUser({ getters, commit }) {
        const response = await this._vm.$api.auth.getMyPatient();
        commit('SET_LOGGED_USER', response.data);
    },
    async fetchLoggedUserCommunication({ getters, commit }) {
        const response = await this._vm.$api.auth.getMyPatientCommunication();
        commit('SET_LOGGED_USER_COMMUNICATION', response.data);
    },
    async fetchPatients({ getters, commit }) {
        const response = await this._vm.$api.auth.getAllPatients();
        commit('SET_PATIENTS', response.data);
    },
    async registerUser() {
        return this._vm.$api.auth.registerUser();
    },
};

export const kcAuth = {
    namespaced: true,
    actions,
    getters,
    mutations,
    state,
};
